import { useQuery } from 'react-query'
import { makeCoreGetRequest } from 'utils/api'
import { handleQueryError } from 'utils/helpers'
import { toDepositTypesOptions } from './serializers'
import { DEPOSIT_TYPES } from './AdminDashboard/AdminDeposit/AdminDepositModal/constants'
import { AsyncAutocompleteOption } from 'components/core-ui/AsyncAutocomplete/AsyncAutocompleteDefinitions'

export const getDepositTypesOptions = (
  showNotification: Function,
  validateQuery: boolean = true
) => {
  return useQuery(
    ['deposit-type-options'],
    async () => {
      // const types = await makeCoreGetRequest('/shop-reception/deposit-types')
      // TODO get the list from an endpoint
      return toDepositTypesOptions(DEPOSIT_TYPES) || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de depozit.',
          showNotification
        ),

      enabled: validateQuery
    }
  )
}

export const getShopOptions = (showNotification: Function) => {
  return useQuery(
    ['shop-codes'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception/shops/codes')

      const resultOptions = result.list.map(
        (item: any): AsyncAutocompleteOption => ({
          label: item.displayName,
          value: item.code
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea magazinelor.', showNotification)
    }
  )
}

export const getAllShopOptions = (showNotification: Function) => {
  return useQuery(
    ['all-shop-codes'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception/shops/all-codes')

      const resultOptions = result.list.map(
        (item: any): AsyncAutocompleteOption => ({
          label: item.displayName,
          value: item.code
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea magazinelor.', showNotification)
    }
  )
}

export const getShopOptionsWithReturoId = (showNotification: Function) => {
  return useQuery(
    ['shop-codes'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception/shops/codes')

      const resultOptions = result.list.map(
        (item: any): AsyncAutocompleteOption => ({
          label: `${item.displayName} - ${item.idReturo}`,
          value: item.code
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea magazinelor.', showNotification)
    }
  )
}

export const getShopTypesOptions = (showNotification: Function) => {
  return useQuery(
    ['shop-types'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception/products/types')

      const resultOptions = result.map(
        (item: any): AsyncAutocompleteOption => ({
          label: item.value,
          value: item.key
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de magazine.',
          showNotification
        )
    }
  )
}

export const getSensitiveShopTypes = (showNotification: Function) => {
  return useQuery(
    ['sensitive-shop-types'],
    async () => {
      const result = await makeCoreGetRequest(`/shop-reception/products/sensitives/shop-types`)

      const resultOptions = result.map(
        (item: any): AsyncAutocompleteOption => ({
          label: item.shopTypeDescription,
          value: item.shopType
        })
      )

      return resultOptions || []
    },
    {
      onError: error => handleQueryError(error, 'Nu s-au putut incarca tipurile de magazine.', showNotification)
    }
  )
}

export const getHubOptions = (showNotification: Function) => {
  return useQuery(
    ['hubs'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/hubs/accessible')
      return data.map(item => ({
        label: item.displayName,
        value: item.id
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea huburilor.', showNotification)
    }
  )
}

export const getRegionOptions = (showNotification: Function) => {
  return useQuery(
    ['regions'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception/regions')

      const resultOptions = result.list.map(
        (item: any): AsyncAutocompleteOption => ({
          label: item.name,
          value: item.id
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de magazine.',
          showNotification
        )
    }
  )
}

export const getSupportTypeOptions = (showNotification: Function) => {
  return useQuery(
    ['support-types'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/support-flows/support-types')
      return data.map(item => ({
        label: item.name,
        value: item.id
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de suport.',
          showNotification
        )
    }
  )
}

export const getSupportTypeOptionsById = (showNotification: Function) => {
  return useQuery(
    ['support-types-by-id'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/support-flows/support-types')
      return data.map(item => ({
        label: item.name,
        value: item.id
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de suport.',
          showNotification
        )
    }
  )
}

export const getParentSocietyOptions = (showNotification: Function) => {
  return useQuery(
    ['parent-societies'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception/shops/parent-society')
      const resultOptions = result.map(
        (item: string): AsyncAutocompleteOption => ({
          label: item,
          value: item
        })
      )
      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea societatilor.', showNotification)
    }
  )
}

export const getDepositOptions = (showNotification: Function) => {
  return useQuery(
    ['deposits'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/deposits/accessible`)
      return data.map(item => ({
        label: item.depositName,
        value: item.id
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea depozitelor.', showNotification)
    }
  )
}

export const getDepositCodeOptions = (showNotification: Function) => {
  return useQuery(
    ['deposits'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/deposits/accessible`)
      return data.map(item => ({
        label: item.depositName,
        value: item.depositCode
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea depozitelor.', showNotification)
    }
  )
}

export const getDepositNameOptions = (showNotification: Function) => {
  return useQuery(
    ['deposits'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/deposits/accessible`)
      return data.map(item => ({
        label: item.depositName,
        value: item.depositName
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea depozitelor.', showNotification)
    }
  )
}

export const getRegionTypesOptions = (showNotification: Function) => {
  return useQuery(
    ['regions'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/regions/accessible`)
      return data.map(item => ({
        label: item.name,
        value: item.id
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de regiuni.',
          showNotification
        )
    }
  )
}

export const getStatusOptions = (showNotification: Function) => {
  return useQuery(
    ['status'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/deliveryTicket/statuses`)
      return data.map(item => ({
        label: item.deliveryTicketStatusValue,
        value: item.deliveryTicketStatus
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea depozitelor.', showNotification)
    }
  )
}

export const getDsStatusOptions = (showNotification: Function) => {
  return useQuery(
    ['dsOrderStatusList'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/ds-orders/statuses`)
      return data.map(item => ({
        label: item.dsDeliveryStatusValue,
        value: item.dsDeliveryStatus
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea starea comenzii.', showNotification)
    }
  )
}

export const getLocation = (showNotification: Function) => {
  return useQuery(
    ['location'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/truck/supportTypeFlow`)
      return data.map(item => ({
        label: item.supportTypeFlowValue,
        value: item.supportTypeFlow
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea locatiilor.', showNotification)
    }
  )
}

export const geTruckLocation = (showNotification: Function) => {
  return useQuery(
    ['truck-location'],
    async () => {
      const data = await makeCoreGetRequest(
        `/shop-reception/delivery-trucks/support-types-delivery`
      )
      return data.map(item => ({
        label: item.value,
        value: item.key
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea locatiilor.', showNotification)
    }
  )
}

export const getArrivalType = (showNotification: Function) => {
  return useQuery(
    ['arrival-type'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/delivery-trucks/delivery-types`)
      return data.map(item => ({
        label: item.value,
        value: item.key
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de sosire.',
          showNotification
        )
    }
  )
}

export const getNonCompliantReasonOptions = (showNotification: Function) => {
  return useQuery(
    ['nonCompliantReasons'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/support-flows/non-compliant-reasons')
      return data.map(item => ({
        label: item.value,
        value: item.key
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea motivelor de ne-conformitate.',
          showNotification
        )
    }
  )
}

export const getReturnTruckTypesOptions = (showNotification: Function) => {
  return useQuery(
    ['returnTruckTypes'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/return-trucks/types')
      return data.map(item => ({
        label: item.value,
        value: item.key
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de camion.',
          showNotification
        )
    }
  )
}

export const getReturnTruckStatusOptions = (showNotification: Function) => {
  return useQuery(
    ['returnTruckStatuses'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/return-trucks/status')
      return data.map(item => ({
        label: item.value,
        value: item.key
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea statusurilor camioanelor.',
          showNotification
        )
    }
  )
}

export const getRayonsOptions = (showNotification: Function) => {
  return useQuery(
    ['meti-rayons'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/products/meti-rayons')
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea raioanelor.', showNotification)
    }
  )
}

export const getMetiFamiliesOptions = (showNotification: Function) => {
  return useQuery(
    ['meti-families'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/products/meti-families')
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea familiilor.', showNotification)
    }
  )
}

export const getMetiSubFamiliesOptions = (showNotification: Function) => {
  return useQuery(
    ['meti-sub-families'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/products/meti-sub-families')
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea familiilor.', showNotification)
    }
  )
}

export const getMetiUBOptions = (showNotification: Function) => {
  return useQuery(
    ['meti-ub'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/products/meti-ubs')
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea familiilor.', showNotification)
    }
  )
}

export const getMetiFamiliesByRayonOptions = (showNotification: Function, rayCode: string) => {
  return useQuery(
    ['meti-families-by-rayon', rayCode],
    async () => {
      if (!rayCode) return []

      const data = await makeCoreGetRequest(`/shop-reception/products/meti-families/${rayCode}`)
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea familiilor meti dupa codul de raion.',
          showNotification
        )
    }
  )
}

export const getMetiSubFamiliesByFamilyOptions = (showNotification: Function, famCode: string) => {
  return useQuery(
    ['meti-sub-families-by-family', famCode],
    async () => {
      if (!famCode) return []

      const data = await makeCoreGetRequest(`/shop-reception/products/meti-sub-families/${famCode}`)
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea sub-familiilor meti dupa codul de familie.',
          showNotification
        )
    }
  )
}

export const getMetiUBBySubFamilyOptions = (showNotification: Function, sfaCode: string) => {
  return useQuery(
    ['meti-ub-by-sub-family', sfaCode],
    async () => {
      if (!sfaCode) return []

      const data = await makeCoreGetRequest(`/shop-reception/products/meti-ubs/${sfaCode}`)
      return data.map(item => ({
        label: item.displayValue,
        value: item.code
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea ub-urilor meti dupa codul de sub-familie.',
          showNotification
        )
    }
  )
}

export const getDepositEditFlags = (showNotification: Function) => {
  return useQuery(
    ['deposit-edit-flags'],
    async () => {
      const reponse = await makeCoreGetRequest('/shop-reception/deposits/edit-flags')
      return reponse
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea drepturilor de editare pe depozite.',
          showNotification
        )
    }
  )
}

export const getScreenPermissions = (showNotification: Function, screen: string) => {
  return useQuery(
    ['can-edit-screen-flags', screen],
    async () => {
      const reponse = await makeCoreGetRequest(`/shop-reception/can-edit/${screen}`)
      return reponse
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea drepturilor de editare pentru ecrane.',
          showNotification
        )
    }
  )
}

export const getReturoNoticeStatusOptions = (showNotification: Function) => {
  return useQuery(
    ['returo-notice-status-options'],
    async () => {
      const reponse = await makeCoreGetRequest('/shop-reception/returo-notice/statuses')
      return reponse.map(
        (item: ReturoNoticeStatus): AsyncAutocompleteOption => ({
          value: item.returoNoticeStatus,
          label: item.returoNoticeStatusValue
        })
      )
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea llistei de statusuri pentru PV-uri.',
          showNotification
        )
    }
  )
}

export const getDsSupportTypeOptions = (showNotification: Function) => {
  return useQuery(
    ['support-types'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/ds-support-types')
      return data.list?.map(item => ({
        label: item.code,
        value: item.id
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de suport.',
          showNotification
        )
    }
  )
}

export const getDsSupportTypeFilterOptions = (showNotification: Function) => {
  return useQuery(
    ['support-types-filter'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/ds-support-types')
      return data.list?.map(item => ({
        label: item.code,
        value: item.name
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de suport.',
          showNotification
        )
    }
  )
}

export const getDsSupplierList = (showNotification: Function) => {
  return useQuery(
    ['direct-suppliers'],
    async () => {
      const data = await makeCoreGetRequest('/shop-reception/ds-direct-suppliers/dropdown')
      return data.map(item => ({
        label: item.displayName,
        value: item.supplierCode
      }))
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de suport.',
          showNotification
        )
    }
  )
}
